module.exports = __webpack_public_path__ + "img/lg_ring_r_l_0_null.c6af4cf9.png";